<template>
  <div>
    <v-card
        height="350"
        class="rounded-lg white" flat
    >
      <v-card-title class=" mr-3  secondary--text" style="font-size: medium; margin-top: -10px">
        <v-img class="ml-2" src="/img/icons/factor.svg" max-width="25"></v-img>
        لیست فاکتور ها
        <v-spacer></v-spacer>
        <v-tooltip right v-if="summary">
          <template v-slot:activator="{ on, attrs }">
            <v-btn v-bind="attrs" v-on="on" fab icon class="mr-3" href="/report/lastFactorsList" target="_blank">
              <v-img class="" src="/img/icons/info_circle.svg" max-width="23"></v-img>
            </v-btn>
          </template>
          مشاهده کامل
        </v-tooltip>
        <v-tooltip right color="secondary">
          <template v-slot:activator="{ on, attrs }">
            <v-btn v-bind="attrs" v-on="on" fab icon class="" href="/panel/cheque/form/c/false">
              <v-img class="" src="/img/icons/plus_doc.svg" max-width="26"></v-img>
            </v-btn>
          </template>
          ثبت فاکتور جدید
        </v-tooltip>

      </v-card-title>
      <v-tabs style="margin-top: -10px" class="rounded-lg white--text"
              background-color="lightSecondary" color="primary">
        <v-tab class="white--text " active-class="mr-5 secondary" @click="getSaleFactors()">
          <span> فروش</span>
        </v-tab>
        <v-tab class="white--text " active-class=" secondary" @click="getPreSaleFactors()">
          <span>پیش فاکتور فروش</span>
        </v-tab>
        <v-tab class="white--text " active-class=" secondary" @click="getBackFromSaleFactors()">
          <span> برگشت از فروش</span>
        </v-tab>
        <v-tab class="white--text " active-class=" secondary" @click="getBuyFactors()">
          <span> خرید</span>
        </v-tab>
        <v-tab class="white--text " active-class=" secondary" @click="getPreBuyFactors()">
          <span>پیش فاکتور خرید</span>
        </v-tab>
        <v-tab class="white--text " active-class=" secondary" @click="getBackFromBuyFactors()">
          <span> برگشت از خرید</span>
        </v-tab>
        <v-tab-item class="pt-4">
          <v-simple-table class="mr-2 ml-2 rounded-b-lg">
            <template v-slot:default>
              <thead>
              <tr>
                <th class="text-center">
                  شماره
                </th>
                <th class="text-center">
                  تاریخ
                </th>
                <th class="text-center">
                  مشتری
                </th>
                <th class="text-center">`
                  شرح
                </th>
                <th class="text-center">
                  مبلغ
                </th>
              </tr>
              </thead>
              <tbody>
              <tr v-for="factor in saleFactors" @click="$router.push(to(factor))" class="cursor-pointer">
                <td class="text-center">{{ factor.code }}</td>
                <td class="text-center">{{ factor.date }}</td>
                <td class="text-center">{{ factor.account.name }}</td>
                <td class="text-center">{{ factor.explanation }}</td>
                <td class="text-center">{{ factor.round_total_sum | toMoney(0) }}</td>
              </tr>
              </tbody>
            </template>
          </v-simple-table>
        </v-tab-item>
        <v-tab-item class="pt-4">
          <v-simple-table class="mr-2 ml-2 rounded-b-lg">
            <template v-slot:default>
              <thead>
              <tr>
                <th class="text-center">
                  شماره
                </th>
                <th class="text-center">
                  تاریخ
                </th>
                <th class="text-center">
                  مشتری
                </th>
                <th class="text-center">
                  شرح
                </th>
                <th class="text-center">
                  مبلغ
                </th>
              </tr>
              </thead>
              <tbody>
              <tr v-for="factor in preSaleFactors" @click="$router.push(to(factor))" class="cursor-pointer">
                <td class="text-center">{{ factor.code }}</td>
                <td class="text-center">{{ factor.date }}</td>
                <td class="text-center">{{ factor.account.name }}</td>
                <td class="text-center">{{ factor.explanation }}</td>
                <td class="text-center">{{ factor.round_total_sum | toMoney(0) }}</td>
              </tr>
              </tbody>
            </template>
          </v-simple-table>
        </v-tab-item>
        <v-tab-item class="pt-4">
          <v-simple-table class="mr-2 ml-2 rounded-b-lg">
            <template v-slot:default>
              <thead>
              <tr>
                <th class="text-center">
                  شماره
                </th>
                <th class="text-center">
                  تاریخ
                </th>
                <th class="text-center">
                  مشتری
                </th>
                <th class="text-center">
                  شرح
                </th>
                <th class="text-center">
                  مبلغ
                </th>
              </tr>
              </thead>
              <tbody>
              <tr v-for="factor in backFromSaleFactors" @click="$router.push(to(factor))" class="cursor-pointer">
                <td class="text-center">{{ factor.code }}</td>
                <td class="text-center">{{ factor.date }}</td>
                <td class="text-center">{{ factor.account.name }}</td>
                <td class="text-center">{{ factor.explanation }}</td>
                <td class="text-center">{{ factor.round_total_sum | toMoney(0) }}</td>
              </tr>
              </tbody>
            </template>
          </v-simple-table>
        </v-tab-item>
        <v-tab-item class="pt-4">
          <v-simple-table class="mr-2 ml-2 rounded-b-lg">
            <template v-slot:default>
              <thead>
              <tr>
                <th class="text-center">
                  شماره
                </th>
                <th class="text-center">
                  تاریخ
                </th>
                <th class="text-center">
                  فروشنده
                </th>
                <th class="text-center">
                  شرح
                </th>
                <th class="text-center">
                  مبلغ
                </th>
              </tr>
              </thead>
              <tbody>
              <tr v-for="factor in buyFactors" @click="$router.push(to(factor))" class="cursor-pointer">
                <td class="text-center">{{ factor.code }}</td>
                <td class="text-center">{{ factor.date }}</td>
                <td class="text-center">{{ factor.account.name }}</td>
                <td class="text-center">{{ factor.explanation }}</td>
                <td class="text-center">{{ factor.round_total_sum | toMoney(0) }}</td>
              </tr>
              </tbody>
            </template>
          </v-simple-table>
        </v-tab-item>
        <v-tab-item class="pt-4">
          <v-simple-table class="mr-2 ml-2 rounded-b-lg">
            <template v-slot:default>
              <thead>
              <tr>
                <th class="text-center">
                  شماره
                </th>
                <th class="text-center">
                  تاریخ
                </th>
                <th class="text-center">
                  فروشنده
                </th>
                <th class="text-center">
                  شرح
                </th>
                <th class="text-center">
                  مبلغ
                </th>
              </tr>
              </thead>
              <tbody>
              <tr v-for="factor in preBuyFactors" @click="$router.push(to(factor))" class="cursor-pointer">
                <td class="text-center">{{ factor.code }}</td>
                <td class="text-center">{{ factor.date }}</td>
                <td class="text-center">{{ factor.account.name }}</td>
                <td class="text-center">{{ factor.explanation }}</td>
                <td class="text-center">{{ factor.round_total_sum | toMoney(0) }}</td>
              </tr>
              </tbody>
            </template>
          </v-simple-table>
        </v-tab-item>
        <v-tab-item class="pt-4">
          <v-simple-table class="mr-2 ml-2 rounded-b-lg">
            <template v-slot:default>
              <thead>
              <tr>
                <th class="text-center">
                  شماره
                </th>
                <th class="text-center">
                  تاریخ
                </th>
                <th class="text-center">
                  فروشنده
                </th>
                <th class="text-center">
                  شرح
                </th>
                <th class="text-center">
                  مبلغ
                </th>
              </tr>
              </thead>
              <tbody>
              <tr v-for="factor in backFromBuyFactors" @click="$router.push(to(factor))" class="cursor-pointer">
                <td class="text-center">{{ factor.code }}</td>
                <td class="text-center">{{ factor.date }}</td>
                <td class="text-center">{{ factor.account.name }}</td>
                <td class="text-center">{{ factor.explanation }}</td>
                <td class="text-center">{{ factor.round_total_sum | toMoney(0) }}</td>
              </tr>
              </tbody>
            </template>
          </v-simple-table>
        </v-tab-item>
      </v-tabs>

    </v-card>

  </div>

</template>

<script>
export default {
  name: "FactorsTable",
  components: {},
  props: {
    id: {},
    summary: {
      default: false
    },

  },
  data() {
    return {
      saleFactors: null,
      preSaleFactors: null,
      backFromSaleFactors: null,
      buyFactors: null,
      preBuyFactors: null,
      backFromBuyFactors: null,
    };
  },
  mounted() {
    this.getSaleFactors()
  },
  methods: {
    getSaleFactors(){
      if(this.saleFactors == null){
        this.request({
          url: this.endpoint(
              `reports/lists/factors?limit=${this.list_limit}&offset=0&search=&type=sale&is_pre_factor=false`),
          method: "get",
          success: data => {
            this.saleFactors = data.results
          },
        })
      }
    },
    getPreSaleFactors(){
      if(this.preSaleFactors == null){
        this.request({
          url: this.endpoint(
              `reports/lists/factors?limit=${this.list_limit}&offset=0&search=&type=sale&is_pre_factor=true`),
          method: "get",
          success: data => {
            this.preSaleFactors = data.results
          },
        })
      }
    },
    getBackFromSaleFactors(){
      if(this.backFromSaleFactors == null){
        this.request({
          url: this.endpoint(
              `reports/lists/factors?limit=${this.list_limit}&offset=0&search=&type=backFromSale&is_pre_factor=false`),
          method: "get",
          success: data => {
            this.backFromSaleFactors = data.results
          },
        })
      }
    },
    getBuyFactors(){
      if(this.buyFactors == null){
        this.request({
          url: this.endpoint(
              `reports/lists/factors?limit=${this.list_limit}&offset=0&search=&type=buy&is_pre_factor=false`),
          method: "get",
          success: data => {
            this.buyFactors = data.results
          },
        })
      }
    },
    getPreBuyFactors(){
      if(this.preBuyFactors == null){
        this.request({
          url: this.endpoint(
              `reports/lists/factors?limit=${this.list_limit}&offset=0&search=&type=buy&is_pre_factor=true`),
          method: "get",
          success: data => {
            this.preBuyFactors = data.results
          },
        })
      }
    },
    getBackFromBuyFactors(){
      if(this.backFromBuyFactors == null){
        this.request({
          url: this.endpoint(
              `reports/lists/factors?limit=${this.list_limit}&offset=0&search=&type=backFromBuy&is_pre_factor=false`),
          method: "get",
          success: data => {
            this.backFromBuyFactors = data.results
          },
        })
      }
    },

    to(item) {
      return {
        name: "FactorForm",
        params: {
          id: item.id,
          isPreFactor: item.is_pre_factor,
          type: item.type,

        },
      };
    },
  },
  computed: {
    headers() {
      return [];
    },
    list_limit() {
      let list_limit = 50
      if (this.summary) {
        list_limit = 5
      }
      return list_limit
    },
  },
  updated() {
  },

}
</script>

<style scoped lang="scss">
.cursor-pointer {
  cursor: pointer !important;
}
</style>

